import sassConstants from '@/constants/sass'

export default {
  ALIGN_LEFT: sassConstants.alignLeft,
  ALIGN_CENTER: sassConstants.alignCenter,
  ALIGN_RIGHT: sassConstants.alignRight,
}
